import { gql } from 'apollo-angular';

export const sharedViewerFragment = gql`
  fragment SharedViewer on User {
    id
    email
    secondaryEmail
    title
    firstName
    insertion
    lastName
    fullName
    big
    preferredLanguage
    customSettings
    portfolioEmailFrequency
    workspaceEmailFrequency
    isOnboarded
    isAdmin
    sendManageRolesNotifications
    sendLearningResourceAlertMails
    canManageAnyRoles
  }
`;

export const sharedViewerWithAvatarFragment = gql`
  fragment SharedViewerWithAvatar on User {
    ...SharedViewer
    avatarUrl
    thumbUrl
    fullSizeAvatarUrl
  }
  ${sharedViewerFragment}
`;
